var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS2P3B1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4082 5.3981C14.7388 5.35481 11.5066 10.5392 6.30283 10.4665C5.64088 12.4832 5.30445 14.5924 5.30616 16.7149C5.30616 26.0349 11.6795 33.8649 20.3062 36.0865C28.9328 33.8665 35.3062 26.0365 35.3062 16.7165C35.3062 14.5332 34.9562 12.4315 34.3095 10.4649H34.0562C28.7295 10.4649 25.904 5.44008 20.4082 5.3981Z",
    fill: "#FF6969",
    stroke: "#FF4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS2P3B1);
export default __webpack_public_path__ + "static/media/HomeS2P3B1.e9024aadb2c4696a1ada04f114f90ef4.svg";
export { ForwardRef as ReactComponent };